import React from "react";
import { Link, useLocation } from "react-router-dom";

export const buildSearch = (baseSearch, patch) => {
    const sp = new URLSearchParams(baseSearch || "");
    Object.entries(patch).forEach(([k, v]) => {
        if (v === null || v === undefined) sp.delete(k);
        else sp.set(k, String(v));
    });
    const s = sp.toString();
    return s ? `?${s}` : "";
};


const normalizeTo = (to, location) => {
    if (typeof to !== "string") return { ...to };

    if (to.startsWith("?")) return { pathname: location.pathname, search: to };

    const [pathAndQuery, hashPart] = to.split("#");
    const qIndex = pathAndQuery.indexOf("?");
    const pathname = qIndex >= 0 ? pathAndQuery.slice(0, qIndex) : pathAndQuery;
    const search = qIndex >= 0 ? pathAndQuery.slice(qIndex) : "";

    return {
        pathname,
        search,
        ...(hashPart ? { hash: `#${hashPart}` } : {}),
    };
};

export function ServiceLink({ to, serviceKey, ...rest }) {
    const location = useLocation();

    const next = normalizeTo(to, location);

    const curSp = new URLSearchParams(location.search || "");
    const nextSp = new URLSearchParams(next.search || "");

    const finalService =
        serviceKey ?? nextSp.get("service") ?? curSp.get("service");

    const nextSearch = buildSearch(next.search || "", {
        service: finalService ?? null,
    });

    return <Link {...rest} to={{ ...next, search: nextSearch }} />;
};